import { type SVGProps } from "react"

function ConnectorXs(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={87}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M6 68a2 2 0 0 1-2-2v-6.4a2 2 0 1 1 4 0V66a2 2 0 0 1-2 2Zm0-14.933a2 2 0 0 1-2-2v-12.8a2 2 0 1 1 4 0v12.8a2 2 0 0 1-2 2Zm0-21.334a2 2 0 0 1-2-2v-12.8a2 2 0 0 1 4 0v12.8a2 2 0 0 1-2 2ZM6 10.4a2 2 0 0 1-2-2V2a2 2 0 1 1 4 0v6.4a2 2 0 0 1-2 2Z"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={81}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}

function ConnectorSm(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={138}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M6 121a2 2 0 0 1-2-2v-5.85a2 2 0 1 1 4 0V119a2 2 0 0 1-2 2Zm0-13.65a2 2 0 0 1-2-2v-11.7a2 2 0 1 1 4 0v11.7a2 2 0 0 1-2 2Zm0-19.5a2 2 0 0 1-2-2v-11.7a2 2 0 1 1 4 0v11.7a2 2 0 0 1-2 2Zm0-19.5a2 2 0 0 1-2-2v-11.7a2 2 0 1 1 4 0v11.7a2 2 0 0 1-2 2Zm0-19.5a2 2 0 0 1-2-2v-11.7a2 2 0 1 1 4 0v11.7a2 2 0 0 1-2 2Zm0-19.5a2 2 0 0 1-2-2v-11.7a2 2 0 1 1 4 0v11.7a2 2 0 0 1-2 2Zm0-19.5a2 2 0 0 1-2-2V2a2 2 0 1 1 4 0v5.85a2 2 0 0 1-2 2Z"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={132}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}

function ConnectorMd(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={192}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M6 174a2 2 0 0 1-2-2v-5.667a2 2 0 0 1 4 0V172a2 2 0 0 1-2 2Zm0-13.222a2 2 0 0 1-2-2v-11.334a2 2 0 0 1 4 0v11.334a2 2 0 0 1-2 2Zm0-18.889a2 2 0 0 1-2-2v-11.333a2 2 0 1 1 4 0v11.333a2 2 0 0 1-2 2ZM6 123a2 2 0 0 1-2-2v-11.333a2 2 0 1 1 4 0V121a2 2 0 0 1-2 2Zm0-18.889a2 2 0 0 1-2-2V90.778a2 2 0 1 1 4 0v11.333a2 2 0 0 1-2 2Zm0-18.889a2 2 0 0 1-2-2V71.89a2 2 0 1 1 4 0v11.333a2 2 0 0 1-2 2Zm0-18.889a2 2 0 0 1-2-2V53a2 2 0 1 1 4 0v11.333a2 2 0 0 1-2 2Zm0-18.889a2 2 0 0 1-2-2V34.111a2 2 0 1 1 4 0v11.334a2 2 0 0 1-2 2Zm0-18.888a2 2 0 0 1-2-2V15.222a2 2 0 0 1 4 0v11.334a2 2 0 0 1-2 2Zm0-18.89a2 2 0 0 1-2-2V2a2 2 0 1 1 4 0v5.667a2 2 0 0 1-2 2Z"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={186}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}

function ConnectorLg(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={343}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M6 323a2 2 0 0 1-2-2v-5.981a2 2 0 1 1 4 0V321a2 2 0 0 1-2 2Zm0-13.956a2 2 0 0 1-2-2v-11.963a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2v-11.962a2 2 0 1 1 4 0v11.962a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2v-11.963a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2v-11.962a2 2 0 1 1 4 0v11.962a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2v-11.963a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2v-11.962a2 2 0 1 1 4 0v11.962a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2v-11.963a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2v-11.962a2 2 0 1 1 4 0v11.962a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2v-11.963a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2v-11.962a2 2 0 1 1 4 0v11.962a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2V95.706a2 2 0 1 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2V75.77a2 2 0 1 1 4 0V87.73a2 2 0 0 1-2 2Zm0-19.937a2 2 0 0 1-2-2V55.83a2 2 0 0 1 4 0v11.963a2 2 0 0 1-2 2Zm0-19.938a2 2 0 0 1-2-2V35.894a2 2 0 0 1 4 0v11.962a2 2 0 0 1-2 2ZM6 29.92a2 2 0 0 1-2-2V15.956a2 2 0 0 1 4 0V27.92a2 2 0 0 1-2 2ZM6 9.98a2 2 0 0 1-2-2V2a2 2 0 1 1 4 0v5.981a2 2 0 0 1-2 2Z"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={337}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}

const CONNECTOR_BY_SIZE = {
    xs: ConnectorXs,
    sm: ConnectorSm,
    md: ConnectorMd,
    lg: ConnectorLg,
}

export function ConnectorMobile({
    size,
    ...props
}: SVGProps<SVGSVGElement> & { size: "xs" | "sm" | "md" | "lg" }) {
    const Component = CONNECTOR_BY_SIZE[size]

    return <Component {...props} />
}
